var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"subtitle"},[_vm._v("Options du site internet")]),_c('hr'),_c('website_connection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }